import ScrollMagic from 'scrollmagic';
import isMobile from './utils/detect-mobile';
import editMode from './utils/detect-edit-mode';
import {ROOT_ELEMENT} from './constants';

document.addEventListener('DOMContentLoaded', () => {

    const controller = new ScrollMagic.Controller;

    function apearScene(el, startAnimation, cls) {

        el.each(function () {

            new ScrollMagic.Scene({
                triggerElement: this,
                // duration: '100%', // view port height good for responsive animations
                triggerHook: startAnimation,
                reverse: false // animations will happens only once
            })
                .setClassToggle(this, cls)
                .addTo(controller);
        });
    }

    function appendClass(selector, cls) {

        if (selector.length) {

            selector.each(function (index) {

                if (!$(this).hasClass(cls)) {

                    selector.eq(index).addClass(cls);

                }

            })

        }

    }

    const $elements = ['.info-box', '.news-list', '.contact-box', '.slider-swipe', '.sub-head', '.header',
        '.detail-item', '.news-article', '.slider-full', '.services-item', '.illustration', '.content__stick',
        '.cover .image-box', '.illustration-bg'];

    const $cards = ['.card'];

    ROOT_ELEMENT.addEventListener('preloaderEnd', () => {

    $cards.forEach((el, i) => {

      apearScene($($cards[i]), 0.9, 'show');

    });

    });
    if (!isMobile()) {

        ROOT_ELEMENT.addEventListener('preloaderEnd', () => {

            $elements.forEach((el, i) => {

                apearScene($($elements[i]), 0.9, 'show');

            });

        });

    } else {

        $elements.forEach((el, i) => {

            appendClass($($elements[i]), 'show');

        });

    }

    // for edit mode

    if (editMode()) {

        $elements.forEach((el, i) => {

            appendClass($($elements[i]), 'show');

        });

    }

});



// WEBPACK FOOTER //
// ./scripts/scrollmagic.js